'use strict'

module.exports = {
  kConstruct: Symbol('constructable')
}
